exports = module.exports = require("../../../../node_modules/_css-loader@0.26.4@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".i-affix[data-v-27066d0e]{position:fixed;z-index:99999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.26.4@css-loader?minimize!./~/_vue-loader@10.3.0@vue-loader/lib/style-rewriter.js?id=data-v-27066d0e&scoped=true!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=styles&index=0!./src/components/affix/src/affix.vue
// module id = 472
// module chunks = 0